import Model from "./Model";
import MaterialModel from './MaterialModel';
import BoardModel from './BoardModel';

export default class ExamGroupModel extends Model {
  id: number;
  name: string;
  description: string;
  examCount: number;

  static __typename: string = "ExamGroup";

  constructor(examGroup: any, getters: any) {
    super(getters);
    this.id = examGroup.id;
    this.name = examGroup.name;
    this.description = examGroup.description;
    this.examCount = examGroup.examCount;
  }

  boardsOfExamGroup(): BoardModel[] {
    return this.getters.materialsByExamGroupId(this.id)
      .filter((material: MaterialModel) => material.boardId)
      .map((material: MaterialModel) => material.board())
  }
}